// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	const windowWidth = screen.width;

	// Menu Functionality
	if(document.getElementById("header")){
		let menuContent = document.getElementById("navigationBox");
		let header = document.getElementById("header");
		let menuBtn = document.querySelector("[data-show_nav]");
		let closeBtn = document.querySelector("[data-close_nav]");
		// Show
		menuBtn.addEventListener('click', function (e) {
			menuContent.classList.add("open");
			header.classList.add("menuOpen");
			document.querySelector("body").classList.add("no-scroll");
		});
		// Close
		closeBtn.addEventListener('click', function (e) {
			menuContent.classList.remove("open");
			header.classList.remove("menuOpen");
			document.querySelector("body").classList.remove("no-scroll");
		});
	}



	/* Arrows Change Month Events Calendar */
	if(document.getElementsByClassName('js-month-prev').length > 0){
		document.querySelectorAll('.js-month-prev').forEach(prev => {
			let nextWeek = prev.nextElementSibling;
			let nextPrev = nextWeek.nextElementSibling;
			prev.addEventListener('click', function () {
				let targetMonth = prev.dataset.date;
				if(prev.dataset.limit !== nextWeek.dataset.month){ 
					nextPrev.dataset.date = nextWeek.dataset.month;
					nextWeek.dataset.month = targetMonth;
					modifyMonth(prev,false,nextWeek);
					getEvents(targetMonth);
				}
			})
		})
		document.querySelectorAll('.js-month-next').forEach(next => {
			let nextWeek = next.previousElementSibling;
			let prevNext = nextWeek.previousElementSibling;
			next.addEventListener('click', function () {
				let targetMonth = next.dataset.date;
				prevNext.dataset.date = nextWeek.dataset.month;
				nextWeek.dataset.month = targetMonth;
				modifyMonth(next,true,nextWeek);
				getEvents(targetMonth);

			})
		})
	};

	// Menus
	if(document.getElementsByClassName("menu")[0]){
		let menuCategories = document.querySelectorAll(".menu .menu__tabs .js-menu-tab");
		let menusSelector = document.getElementById("menusSelector");
		let ulMenu = document.querySelector(".menu ul");
		for(let c = 0; c < menuCategories.length; c++){
			menuCategories[c].addEventListener('click', function (e) {
				e.preventDefault();

				let currentCat = this.getAttribute("data-tag");
				document.querySelectorAll(".menu [data-tag]").forEach(item => { item.classList.remove('active'); })
				document.querySelectorAll(`.menu [data-tag="${currentCat}"] `).forEach(item => { item.classList.add('active'); })

				if(menusSelector){
					menusSelector.value = currentCat;
				}
				ulMenu.classList.remove("open");

			});
			menuCategories[0].click();
		}
		if(menusSelector){
			menusSelector.addEventListener('click', function () {
				ulMenu.classList.add("open");
			})
		}
	}


	function modifyMonth(el,add,nextWeek){
		let currentTarget = el.dataset.date.split('-');
		let dateConvert = new Date(currentTarget[1],parseInt(currentTarget[0]) - 1, 1);
		nextWeek.innerHTML = dateConvert.toLocaleString('default', { month: 'long' });
		if(add){
			dateConvert.setMonth(dateConvert.getMonth() + 1);
		} else {
			dateConvert.setMonth(dateConvert.getMonth() - 1);
		}
	
		let finalMonth = (dateConvert.getMonth() + 1)  < 10 ? '0' + (dateConvert.getMonth() + 1) : (dateConvert.getMonth() + 1) ;
		el.dataset.date = finalMonth + '-' +dateConvert.getFullYear();
		
	}
	
	
	document.addEventListener('DOMContentLoaded', () => {

		/* Lightbox Copy */
		const customLightbox = new LBX('.js-lbx-copy', {
            customClass: 'lbx-copy',
        });

	})

	// For Offers Template
	if (document.getElementById('terms_btn')) {
		let btnTerms = document.getElementById('terms_btn');
		let termsInfo = document.getElementById('terms_info');
		let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
		btnTerms.addEventListener('click', function(e) {
			e.preventDefault();
			termsInfo.classList.toggle('active');
			btnTerms.classList.toggle('active');
			if(termsInfo.classList.contains('active')){
				termsInfo.style.height = termsInfoHeight+"px";
			}else{
				termsInfo.style.height = 0+"px";
			}
		});
	}
/*
	//Hover Menu
	let currentMenuItem = $("#privary-navigation a.active").parent().index();
	console.log(currentMenuItem);
	$(".menu-hovers .slide:eq(" + currentMenuItem + ")").addClass("active");
	$("#privary-navigation > .privary-navigation__item > a").hover(function () {
	
	});

	let currentMenuItem = document.querySelectorAll("#privary-navigation a.active");
	let slide = document.querySelectorAll(`.menu-hovers .slide[${currentMenuItem}`);
	slide.forEach(item => {
		console.log(item.classList.add('active'));
	})
	let item1 = document.querySelectorAll("#privary-navigation > .privary-navigation__item > a");
	item1.forEach(item => {
		let hoverItem = $(this).parent().index();
		let hoverItem = $(this).parent().index();

		$(".menu-hovers .slide").removeClass('active');
		$(".menu-hovers .slide:eq(" + hoverItem + ")").addClass("active");
	})
	*/


    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

const logo = document.getElementsByClassName("header__logo")[0].firstElementChild;
const logoURL = logo.getAttribute("src");
const logoScrollURL = logo.getAttribute("data-scroll");

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
		if(st > 80){
			if(!document.getElementById('header').classList.contains('scroll')){
				document.getElementById('header').classList.add('scroll');
				logo.setAttribute("src", logoScrollURL);
			}
		} else {
			if(document.getElementById('header').classList.contains('scroll')){
				document.getElementById('header').classList.remove('scroll');
				logo.setAttribute("src", logoURL);
			}
		}
		if(!document.querySelector(".top-content")){
			document.getElementById('header').classList.add('scroll');
			logo.setAttribute("src", logoScrollURL);
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** ADA Function to modify Menu **/

document.addEventListener('DOMContentLoaded', () => {
	const skipSelectors = [
		'.privary-navigation__item a',
		'.social-media a',
		'.secondary-navigation__item a',
		'.images .menu-images'
	];


	skipSelectors.forEach(selector => {
		const elements = document.querySelectorAll(selector);
		if (elements.length > 0) {
			elements.forEach(element => {
				element.setAttribute('tabindex', '-1');
			});
		}
	});
});

/** ADA Tab Links Functionality for Keyboard Navigation **/

const navigationBox = document.getElementById('navigationBox');
const menuBtn = document.querySelector('.close-icon');
const closeNavButton = document.querySelector('[data-close_nav]');
const reserveTableLink = document.querySelector('.wrapper .right-side .opentable');
const primaryNavLinks = document.querySelectorAll('#primary-nav a');
const socialIconsLinks = document.querySelectorAll('.social-media a');
const secondaryNavLinks = document.querySelectorAll('#secondary-nav a');

function setTabIndex(value) {
    [closeNavButton, reserveTableLink, ...primaryNavLinks, ...socialIconsLinks, ...secondaryNavLinks]
        .filter(el => el)
        .forEach(el => el.setAttribute('tabindex', value));
}

document.addEventListener('focusin', function (event) {
    setTabIndex(navigationBox.classList.contains('open') || !navigationBox.contains(event.target) ? 0 : -1);
});

if (menuBtn) {
    menuBtn.addEventListener('click', () => {
        navigationBox.classList.add('open');
        setTabIndex(0);
    });
}

if (closeNavButton) {
    closeNavButton.addEventListener('click', () => {
        navigationBox.classList.remove('open');
        setTabIndex(-1);
    });
}
